import CloseIcon from "../../../assets/img/closeIcon.svg";
import Cancelimg from "../../../assets/img/cancel-01.svg";
import useTranslator from "../../../hooks/useTranslator";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { formatPropertyAddress, haveValue } from "../../../helper/common";
import AuthContext from "../../../context/auth/AuthContext";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../../Utils/workspaceRoleCapabilities";
import { Tooltip as ReactTooltip } from "react-tooltip";

const AddPropertyModal = ({
  isOpen,
  onClose,
  properties,
  profile,
  handleUnlinkProperty,
  handleLinkProperty,
}) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { user } = useContext(AuthContext);
  const [searchText, setSearchText] = useState("");
  const [loadingPropertyIds, setLoadingPropertyIds] = useState([]);
  const { workspaceId } = useParams();
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  const getName = () => {
    if (haveValue(searchText)) {
      const lowerSearchText = searchText.toLowerCase();

      return (properties ?? []).filter((property) => {
        const addressParts = [
          property?.street ?? "",
          property?.street_number ? String(property.street_number) : "",
          property?.floor_number ?? "",
          property?.flat_number ?? "",
        ];

        const fullAddress = addressParts.join(" ").toLowerCase();

        return fullAddress.includes(lowerSearchText);
      });
    } else {
      return (properties ?? []).filter((property) =>
        profile?.propertyid?.includes(property._id)
      );
    }
  };

  const handleLinkClick = async (propertyId) => {
    setLoadingPropertyIds((prev) => [...prev, propertyId]);
    try {
      await handleLinkProperty(propertyId);
    } finally {
      setLoadingPropertyIds((prev) => prev.filter((id) => id !== propertyId));
    }
  };

  const handleUnlinkClick = async (propertyId) => {
    setLoadingPropertyIds((prev) => [...prev, propertyId]);
    try {
      await handleUnlinkProperty(propertyId);
    } finally {
      setLoadingPropertyIds((prev) => prev.filter((id) => id !== propertyId));
    }
  };

  return (
    isOpen && (
      <div className="wrapper-modal" onClick={onClose}>
        <div
          className={`doc-history-popup total-salary-modal share-profile-modal addPropertyModal ${
            isOpen ? "open" : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <span className="drawerIcon" onClick={onClose} />
          <div>
            <div className="doc-history-header">
              <div className="d-flex align-items-center custom-gap-2">
                <img
                  src={CloseIcon}
                  alt=""
                  className="doc-history-close-btn"
                  onClick={onClose}
                />
                <h4 className="custom-modal-heading">
                  {_t("linkedProperties")}
                </h4>
              </div>
            </div>
          </div>
          <div className="listWrapper">
            <div className="tabs-box-pattern">
              <div className="tabs-item d-block">
                <div
                  className={`profile-page marless tab-profile-search-header ${
                    haveValue(searchText) ? "profile-page-search" : ""
                  }`}
                >
                  {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                    user?.current_workspace_role
                  ) && (
                    <div className="Search-bar searchbar_cls">
                      <div className="search_bar_edit">
                        <a href="#">
                          <img src={"/images/search-icon-grey.svg"} alt="" />
                        </a>
                        <input
                          type="text"
                          className="custom-input mb-0 input01"
                          placeholder={_t("searchProperty")}
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        {haveValue(searchText) && (
                          <img
                            src={Cancelimg}
                            alt="icon"
                            className="canceicon topRightIcon searchCrossIcon"
                            onClick={() => setSearchText("")}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="edit-profile">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div className="edit-profile">
                          <div className="Shortlisted-Properties"></div>
                          <div
                            className={`d-flex align-items-center custom-gap-2 justify-content-between ${
                              haveValue(searchText) ? "shareProfileHeader" : ""
                            }`}
                          >
                            <h4 className="sharedWithText">
                              {haveValue(searchText) ? _t("searchResult") : ""}
                            </h4>
                          </div>
                          <div className="Notifications-row">
                            {Array.isArray(getName()) &&
                            getName().length > 0 ? (
                              getName()?.map((property) => {
                                const propertyName = formatPropertyAddress(
                                  property,
                                  currentLang
                                );
                                const isLoading = loadingPropertyIds.includes(
                                  property._id
                                );

                                return (
                                  <div
                                    className="Notifications-wapper opacity-wapper px-0 tt"
                                    key={property?._id}
                                  >
                                    <div className="mobile-profile-info-box">
                                      <div className="userImageWrapper">
                                        <img src="/images/home-icon-green.svg" />
                                      </div>
                                      <div className="userDetails">
                                        <h4
                                          className="text-decoration-underline"
                                          onClick={(e) =>
                                            navigate(
                                              `/${workspaceId}/home?propertyId=${property?._id}&propName=${propertyName}`
                                            )
                                          }
                                        >
                                          <div className="cursor-pointer">
                                            {propertyName}
                                          </div>
                                        </h4>
                                      </div>
                                    </div>

                                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <div className="share-it">
                                        {profile?.propertyid?.includes(
                                          property._id
                                        ) ? (
                                          (() => {
                                            const propertyId = property?._id;
                                            const tenantId =
                                              profile?.tenantid?._id;

                                            const selectedProperty = (
                                              profile?.properties ?? []
                                            ).find(
                                              (prop) =>
                                                prop?._id?.toString() ===
                                                propertyId?.toString()
                                            );

                                            const isAwarded =
                                              selectedProperty?.current_tenant?.some(
                                                (tenant) =>
                                                  tenant?.toString() ===
                                                  tenantId?.toString()
                                              );

                                            return (
                                              <>
                                                <Link
                                                  className={`share-btn ${isAwarded ? "disable-button" : ""}`}
                                                  data-tooltip-id={
                                                    isAwarded
                                                      ? "share-btn"
                                                      : undefined
                                                  }
                                                  onClick={(e) => {
                                                    if (isAwarded) {
                                                      e.preventDefault();
                                                      return;
                                                    }
                                                    !isLoading &&
                                                      handleUnlinkClick(
                                                        property?._id
                                                      );
                                                  }}
                                                >
                                                  {isLoading
                                                    ? _t("unlinking") + "..."
                                                    : _t("unLink")}
                                                </Link>
                                                {isAwarded && (
                                                  <ReactTooltip
                                                    id="share-btn"
                                                    noArrow
                                                    className="react-tooltip-styling details-skor-tooltip"
                                                    render={() => (
                                                      <p>
                                                        {_t(
                                                          "tenantUnlinkBlockHoverMessageIfItsAwarded"
                                                        )}
                                                      </p>
                                                    )}
                                                  />
                                                )}
                                              </>
                                            );
                                          })()
                                        ) : (
                                          <Link
                                            onClick={() => {
                                              !isLoading &&
                                                handleLinkClick(property?._id);
                                            }}
                                          >
                                            <img src="/images/share-icon.svg" />
                                            {isLoading
                                              ? _t("linking") + "..."
                                              : _t("link")}
                                          </Link>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <p className="notSharedText text-center">
                                {haveValue(searchText)
                                  ? _t("noDataFound")
                                  : _t(
                                      "youHavetLinkedAnyPropertyWithThisUserYet"
                                    )}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default AddPropertyModal;
